import { Badge, Box } from "@hightouch/htui";
import type { AmpLibraryFileFragment } from "src/graphql";

/** Marks a file someone uploaded, so it never passes for a generated ad on the canvas. */
export function UploadBadge({
  file,
}: {
  file: Pick<AmpLibraryFileFragment, "type">;
}) {
  if (file.type !== "upload") return null;
  return (
    <Box flexShrink={0}>
      <Badge size="sm">Upload</Badge>
    </Box>
  );
}
